// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__32UP0","noInteraction":"EventWrapper_noInteraction__n6m1Q","pointerPassthrough":"EventWrapper_pointerPassthrough__1gHsj"};